export const userInputs = [

  {
    id: 1,
    label: "Name*",
    name: "name",
    type: "text",
    placeholder: "Full Name Here",
  },
  {
    id: 2,
    name: "email",
    label: "Email*",
    type: "email",
    placeholder: "Email Here",
  },
  {
    id: 3,
    label: "User Name*",
    name: "username",
    type: "text",
    placeholder: "e.g Ali123",
  },

];
export const companyInputs = t => [
  {
    id: 'companyInputs1',
    label: t('Company Name (English)'),
    name: 'companyNameEn',
    type: 'text',
    placeholder: t('Company Name Here (English)'),
    required: true
  },
  {
    id: 'companyInputs2',
    name: 'companyNameAr',
    label: t('Company Name (Arabic)'),
    type: 'text',
    placeholder: t('Company Name Here (Arabic)'),
    required: true
  },
  {
    id: 'companyInputs3',
    label: t('Company Address'),
    name: 'companyAddress',
    type: 'text',
    placeholder: 'e.g Ali123',
    required: true
  },
  {
    id: 'companyInputs4',
    label: t('Cr Number'),
    name: 'crNumber',
    type: 'text',
    placeholder: t('CR Number Here'),
    required: false
  },
  {
    id: 'companyInputs5',
    label: t('Company GPS Location ( Lat, Long)'),
    name: 'companyGPSLocation',
    type: 'text',
    placeholder: 'e.g 24.123, 46.123',
    required: false
  },
  {
    id: 'companyInputs6',
    label: t('Landline Number'),
    name: 'landlineNumber',
    type: 'text',
    placeholder: t('Landline Number Here'),
    required: false
  }
]


export const assetCategoryInput = [

  {
    id: "assetCategoryInput1",
    label: "Main Series No*",
    name: "MainSubSeriesNo",
    type: "text",
    placeholder: "Main Series No Here",
  },
  {
    id: "assetCategoryInput2",
    label: "Series No*",
    name: "SeriesNumber",
    type: "text",
    placeholder: "Series No Here",
  },

  {
    id: "MainCategoryCode3",
    label: "Main Category Code*",
    name: "MainCategoryCode",
    type: "text",
    placeholder: "Main Category Code Here",
  },

  {
    id: "assetCategoryInput3",
    label: "Sub Category Code*",
    name: "SubCategoryCode",
    type: "text",
    placeholder: "Sub Category Code Here",
  },
  {
    id: "assetCategoryInput4",
    name: "MainDescription",
    label: "Main Description*",
    type: "text",
    placeholder: "Main Description",
  },
  {
    id: "assetCategoryInput5",
    name: "SubDescription",
    label: "Sub Description*",
    type: "text",
    placeholder: "Sub Description",
  },

];

export const
  locationTagInputs = [

    {
      id: 1,
      label: "Ctr No.*",
      name: "ctr",
      type: "number",
      min: 0,
      placeholder: "Ctr No Here",
    },
    {
      id: 2,
      name: "shortName",
      label: "Short Name*",
      type: "text",
      placeholder: "Short Name Here",
    },
    {
      id: 3,
      label: "Long Name*",
      name: "longName",
      type: "text",
      placeholder: "e.g Ali123",
    },
    {
      id: 4,
      label: "No of Labels*",
      name: "noOfLabels",
      type: "number",
      min: 0,
      placeholder: "e.g Ali123",
    },

  ];



export const otherAssetsCitiesInput = [
  {
    id: "otherAssetsCitiesInput1",
    label: "Region Code*",
    name: "RegionCode",
    type: "text",
    placeholder: "Region Code Here",
    isFieldRequired: true,
  },
  {
    id: "otherAssetsCitiesInput2",
    label: "City Code*",
    name: "CityCode",
    type: "text",
    placeholder: "City Code Here",
    isFieldRequired: true,
  },
  {
    id: "otherAssetsCitiesInput3",
    label: "City Name*",
    name: "CityName",
    type: "text",
    placeholder: "City Name Here",
    isFieldRequired: true,
  },
];

export const assetConditionInput = [
  {
    id: "assetConditionInput1",
    label: "Code*",
    name: "TblConditionCode",
    type: "text",
    placeholder: "Code Here",
    isFieldRequired: true,
  },
  {
    id: "assetConditionInput2",
    name: "TblConditionDescription",
    label: "Description*",
    type: "text",
    placeholder: "Description Here",
    isFieldRequired: true,
  },
];

export const employeeListInput = [
  {
    id: "employeeListInput1",
    label: "Employee ID*",
    name: "EmpID",
    type: "text",
    placeholder: "Employee ID Here",
    isFieldRequired: true,
  },
  {
    id: "employeeListInput2",
    label: "Employee Name*",
    name: "EmpName",
    type: "text",
    placeholder: "Employee Name Here",
    isFieldRequired: true,
  },
  {
    id: "employeeListInput3",
    label: "Employee Region",
    name: "EmpRegion",
    type: "text",
    placeholder: "Employee Region Here",
    isFieldRequired: false,
  },
  {
    id: "employeeListInput4",
    label: "Employee Unit",
    name: "EmpUnit",
    type: "text",
    placeholder: "Employee Unit Here",
    isFieldRequired: false,
  },
  {
    id: "employeeListInput5",
    label: "Employee Division",
    name: "EmpDivision",
    type: "text",
    placeholder: "Employee Division Here",
    isFieldRequired: false,
  },
];

export const brandListInput = [
  {
    id: "brandListInput1",
    label: "Major Category*",
    name: "tblMajorCode",
    type: "text",
    placeholder: "Major Category Code Here",
    isFieldRequired: true,
  },
  {
    id: "brandListInput2",
    label: "Minor Category*",
    name: "TblMakeMainCode",
    type: "text",
    placeholder: "Minor Category Code Here",
    isFieldRequired: true,
  },
  {
    id: "brandListInput3",
    label: "Description*",
    name: "TblMakeName",
    type: "text",
    placeholder: "Brand Description Here",
    isFieldRequired: true,
  },
];

export const departmentInputs = [
  {
    id: "departmentInput1",
    label: "Branch Code*",
    name: "branchcode",
    type: "text",
    placeholder: "Branch Code Here",
    isFieldRequired: true,
  },
  {
    id: "departmentInput2",
    label: "Department Code*",
    name: "DAONumber",
    type: "text",
    placeholder: "Department Code Here",
    isFieldRequired: true,
  },
  {
    id: "departmentInput3",
    label: "Business Unit",
    name: "BusinessUnit",
    type: "text",
    placeholder: "Business Unit Here",
    isFieldRequired: false,
  },
  {
    id: "departmentInput4",
    label: "Business Group",
    name: "BUSINESSGROUP",
    type: "text",
    placeholder: "Business Group Here",
    isFieldRequired: false,
  },
  {
    id: "departmentInput5",
    label: "HR Mapping",
    name: "HRMapping",
    type: "text",
    placeholder: "HR Mapping Here",
    isFieldRequired: false,
  },
  {
    id: "departmentInput6",
    label: "Department Name*",
    name: "DaoName",
    type: "text",
    placeholder: "Department Name Here",
    isFieldRequired: true,
  },
  {
    id: "departmentInput7",
    label: "Department Area",
    name: "DaoArea",
    type: "text",
    placeholder: "Department Area Here",
    isFieldRequired: false,
  },
];

export const RolesInput = [

  {
    id: "RolesInput1",
    label: "Role Id*",
    name: "RoleID",
    type: "text",
    placeholder: "Role Id Here",
    isFieldRequired: true,
  },
  {
    id: "RolesInput2",
    name: "RoleDescription",
    label: "Role Description*",
    type: "text",
    isFieldRequired: true,
    placeholder: "Role Description Here",
  },
];